export const exchangeProductCodes = [
  'ReplacementLifeBridge1',
  'ReplacementLifeBridge2',
  'ReplacementLifeBridge3',
  'ReplacementLifeBridge4',
  'exchange',
  'rollover',
  'AnnuityProductExchange1',
  'AnnuityProductExchange2',
  'AnnuityProductExchange3',
  'AnnuityProductExchange4',
  'AnnuityProductExchange5',
  'AnnuityProductExchange6',
  'AnnuityProductExchange7',
  'AnnuityProductExchange8',
  'AnnuityProductExchange9',
  'AnnuityProductExchange10',
];
